import { calculateNetAvailableHours } from '../components/AvailabilityPeriod/CompleteAvailabilityPeriod';
import { roundToDecimals } from './scheduleUtil';

export const convertToComparableValue = ({
  hours,
  scheduledHours,
  isHoursMode
}) => {
  const value = isHoursMode ? hours : (hours * 100) / scheduledHours;

  return roundToDecimals(value);
};

export const compareEditorValue = ({
  isHoursMode,
  initialAllocatedHours,
  scheduledHours,
  inputValue
}) => {
  const previousValue = convertToComparableValue({
    isHoursMode,
    hours: initialAllocatedHours,
    scheduledHours
  });
  const currentValue = inputValue;

  return roundToDecimals(previousValue) === roundToDecimals(currentValue);
};

export const calculateProjectAllocationHours = ({
  initialTaskAllocationHours,
  initialProjectAllocationHours,
  initialTotalTaskAllocationHours,
  newTaskAllocationHours
}) => {
  const taskAllocationHoursDelta =
    newTaskAllocationHours - initialTaskAllocationHours;

  let projectAllocationHoursDelta = taskAllocationHoursDelta;

  if (
    taskAllocationHoursDelta > 0 &&
    initialProjectAllocationHours > initialTotalTaskAllocationHours
  ) {
    projectAllocationHoursDelta = Math.max(
      0,
      initialTotalTaskAllocationHours +
        taskAllocationHoursDelta -
        initialProjectAllocationHours
    );
  }

  if (
    taskAllocationHoursDelta < 0 &&
    initialProjectAllocationHours < initialTotalTaskAllocationHours
  ) {
    projectAllocationHoursDelta = Math.min(
      0,
      initialTotalTaskAllocationHours +
        taskAllocationHoursDelta -
        initialProjectAllocationHours
    );
  }

  return Math.max(
    0,
    initialProjectAllocationHours + projectAllocationHoursDelta
  );
};

export const getNewAvailabilityHours = ({
  workHours,
  otherProjectAllocationHours,
  newProjectAllocationHours
}) =>
  workHours -
  Math.max(otherProjectAllocationHours, 0) -
  newProjectAllocationHours;

export const getNewRemainingProjectAllocationHours = ({
  newProjectAllocationHours,
  otherTaskAllocationHours,
  newTaskAllocationHours
}) =>
  newProjectAllocationHours - otherTaskAllocationHours - newTaskAllocationHours;

export const getRemainingAndAvailableValuesFunction = ({
  workHours,
  scheduledHours,
  initialTaskAllocationHours,
  initialTotalTaskAllocationHours,
  initialProjectAllocationHours,
  otherProjectAllocationHours,
  isCompleteResourceAllocationPermissionEnabled
}) => ({ newTaskAllocationHours, isHoursMode }) => {
  const newProjectAllocationHours = isCompleteResourceAllocationPermissionEnabled
    ? calculateProjectAllocationHours({
        initialTaskAllocationHours,
        initialProjectAllocationHours,
        initialTotalTaskAllocationHours,
        newTaskAllocationHours
      })
    : initialProjectAllocationHours;

  const otherTaskAllocationHours =
    initialTotalTaskAllocationHours - initialTaskAllocationHours;

  const newRemainingProjectAllocationHours = getNewRemainingProjectAllocationHours(
    {
      newProjectAllocationHours,
      otherTaskAllocationHours,
      newTaskAllocationHours
    }
  );

  const availableHours = workHours - Math.max(otherProjectAllocationHours, 0);

  const netAvailableHours = calculateNetAvailableHours({
    availableHours,
    allocatedHours: newProjectAllocationHours
  });

  return {
    availableValue: convertToComparableValue({
      hours: netAvailableHours,
      isHoursMode,
      scheduledHours
    }),
    remainingValue: convertToComparableValue({
      hours: newRemainingProjectAllocationHours,
      isHoursMode,
      scheduledHours
    })
  };
};
